export type Pair<T, U> = [T, U];

export interface Author {
  firstName: string;
  familyName?: string;
}

export interface Sentence {
  text: string;
  words: string[];
  syllableCount: number;
}

export interface SentenceDTO {
  text: string;
  readability: Readability;
}

export interface Paragraph {
  sentences: Sentence[];
  wordCount: number;
  syllableCount: number;
}

export class Readability {
  fleschReadingEase = 0.0;

  fleschKincaidGradeLevel = 0.0;

  daleChallScore = undefined as number | undefined;

  papersDomainScore = undefined as number | undefined;

  constructor(
    fleschReadingEase: number,
    fleschKincaidGradeLevel: number,
    daleChallScore: number | undefined = undefined,
    papersDomainScore: number | undefined = undefined,
  ) {
    this.fleschReadingEase = fleschReadingEase;
    this.fleschKincaidGradeLevel = fleschKincaidGradeLevel;
    this.daleChallScore = daleChallScore;
    this.papersDomainScore = papersDomainScore;
  }

  static from({
    fleschReadingEase,
    fleschKincaidGradeLevel,
    daleChallScore,
    papersDomainScore,
  }: {
    fleschReadingEase: number;
    fleschKincaidGradeLevel: number;
    daleChallScore: number | undefined;
    papersDomainScore: number | undefined;
  }): Readability {
    return new Readability(
      fleschReadingEase,
      fleschKincaidGradeLevel,
      daleChallScore,
      papersDomainScore,
    );
  }

  static zero(): Readability {
    return new Readability(0, 0, 0, 0);
  }

  minus(other: Readability): Readability {
    return new Readability(
      this.fleschReadingEase - other.fleschReadingEase,
      this.fleschKincaidGradeLevel - other.fleschKincaidGradeLevel,
      (this.daleChallScore && other.daleChallScore)
        ? this.daleChallScore - other.daleChallScore
        : undefined,
      (this.papersDomainScore && other.papersDomainScore)
        ? this.papersDomainScore - other.papersDomainScore
        : undefined,
    );
  }
}
